/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/**
 * @author Shalini Jha
 * @name RecentUploads
 * @description A component that renders the list of recent uploaded files
 */
import React from 'react';
import clsx from 'clsx';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ModalDialog from '../ModalDialog';
import ErrorListComponent from './ErrorListComponent';
import styles from './BulkUpload.module.css';
import { CustomToolTip } from '../ToolTips';
// import { ProcessingStatusTooltip, ErrorLabelTooltip, FileReceiptTooltip } from './constants';
import { Utilities, AppUtils } from '@gscope-mfe/app-bridge';
import Message from '../Message';
import { MaterialUiIcons, MaterialUiCore } from '@gscope-mfe/common-libs';
const RefreshRoundedIcon = MaterialUiIcons.RefreshRounded,
    { CircularProgress } = MaterialUiCore,
    { generateRandomKey } = Utilities;
export const renderUploadStatus = (status, summary, trans) => {
    if (status === 'F') {
        return (
            <CustomToolTip title={trans('bulkUpload.constProcessingStatusTooltip')}>
                <span className="statusLabel statusLabelRed statusLabel-sm">{trans('bulkUpload.failed')}</span>
            </CustomToolTip>
        );
    }

    if (status === 'S') {
        if (summary.total === 0) {
            return (
                <CustomToolTip title={trans('bulkUpload.constProcessingStatusTooltip')}>
                    <span className="statusLabel statusLabelRed statusLabel-sm">
                        {trans('bulkUpload.recordsNotFound')}
                    </span>
                </CustomToolTip>
            );
        }

        return (
            <CustomToolTip title={trans('bulkUpload.constProcessingStatusTooltip')}>
                <span className="statusLabel statusLabelGreen statusLabel-sm">{trans('bulkUpload.completed')}</span>
            </CustomToolTip>
        );
    }
};
export const renderErrorCount = (file, showErrorModal, trans) => (
    <CustomToolTip title={trans('bulkUpload.constErrorLabelTooltip')}>
        <span
            className={styles.recentUploads_errorLabel}
            onClick={
                /* istanbul ignore next */
                () => showErrorModal(file.fileName, file.transactionId, file.status)
            }
        >
            {file.summary.errors} {trans('bulkUpload.errors')}
        </span>
    </CustomToolTip>
);
export const renderFileItems = (files, showErrorModal, trans) =>
    files.map(
        (file, index) =>
            index < 5 && (
                <div className={styles.recentUploads_fileDetail} key={generateRandomKey()}>
                    <div className={styles.recentUploads_fileMetaData}>
                        <div className={styles.recentUploads_fileName}>{file.fileName}</div>
                        {renderUploadStatus(file.status, file.summary, trans)}
                        <div className={styles.recentUploads_timeStamp}>
                            {moment(file.uploadDate).format('MMM Do YYYY, HH:mm')}
                        </div>
                    </div>
                    {file.summary.errors > 0 && renderErrorCount(file, showErrorModal, trans)}
                    {file.status != 'F' ? (
                        <CustomToolTip title={trans('bulkUpload.constFileReceiptTooltip')}>
                            <span className={clsx('sct-icon icon-Check-Circle-18', styles.recentUploads_checkIcon)} />
                        </CustomToolTip>
                    ) : null}
                </div>
            ),
    );

const RecentUploads = ({ files, showTIDcolumn, updateUploadHistory, trans }) => {
    const [open, setOpen] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState({});
    const [isLoading, setLoader] = React.useState(true);
    const { moduleLanguage } = AppUtils.get().bulkUploadConfig;

    const handleClose = () => setOpen(false);

    const handleRefresh = () => {
        setLoader(true);
        updateUploadHistory();
    };

    const showErrorModal = (fileName, transactionId, status) => {
        setSelectedFile({ ...selectedFile, fileName, transactionId, status });
        setOpen(true);
    };

    React.useEffect(() => {
        setLoader(false);
    }, [files]);
    return (
        <>
            <div className={styles.recentUploads_root} id="recentUploads">
                <div className={styles.recentUploads_warningMsg}>
                    <Message variant="warning" style="outlined" message={trans('bulkUpload.refreshNoteMsg')} />
                </div>
                {isLoading && (
                    <div className={styles.recentUploads_loaderDiv}>
                        <CircularProgress color="secondary" size="2rem" className={styles.recentUploads_ajaxLoader} />
                    </div>
                )}
                <div className={styles.recentUploads_headerContainer}>
                    <h6>
                        {trans('bulkUpload.recentUploads')}
                        <span className="updateuploadhistory" onClick={() => handleRefresh()}>
                            <CustomToolTip title={trans('bulkUpload.refreshProcessingStatus')}>
                                <RefreshRoundedIcon className={styles.recentUploads_refresh} />
                            </CustomToolTip>
                        </span>
                    </h6>
                    <Link
                        to={{
                            pathname: '/bulkupload/history',
                            state: {
                                showTIDcolumn,
                            },
                        }}
                    >
                        {trans('bulkUpload.viewAll')}
                    </Link>
                </div>
                <div className={styles.recentUploads_fileListContainer}>
                    {renderFileItems(files, showErrorModal, trans)}
                </div>
            </div>
            <ModalDialog
                title={
                    <div>
                        {trans('bulkUpload.errorReport')} {selectedFile.fileName}
                    </div>
                }
                open={open}
                handleClose={handleClose}
            >
                <ErrorListComponent
                    moduleLanguage={moduleLanguage}
                    transactionId={selectedFile.transactionId}
                    status={selectedFile.status}
                    trans={trans}
                />
            </ModalDialog>
        </>
    );
};

RecentUploads.propTypes = {
    files: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    updateUploadHistory: PropTypes.func.isRequired,
};
export default RecentUploads;
